module.exports = __webpack_public_path__ + "media/images/color_admin_v3/gallery/gallery-6-dea46ac8ab57da69e83b036a3b5f02cd.jpg";